// extracted by mini-css-extract-plugin
export default {"icon":"ModeSwitch_icon__+C7nz","title":"ModeSwitch_title__2WHl3","container":"ModeSwitch_container__o99D-","btn":"ModeSwitch_btn__lCk8Y","btnActive":"ModeSwitch_btnActive__GCDnD"};